import { render, staticRenderFns } from "./PreguntasPorServicioTab.vue?vue&type=template&id=22a383c5&scoped=true&"
import script from "./PreguntasPorServicioTab.vue?vue&type=script&lang=js&"
export * from "./PreguntasPorServicioTab.vue?vue&type=script&lang=js&"
import style0 from "./PreguntasPorServicioTab.vue?vue&type=style&index=0&id=22a383c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a383c5",
  null
  
)

export default component.exports